import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconShare: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15 7.99967L8.33333 2.33301V5.66634C2.66667 5.66634 1 7.99967 1 13.6663C2 11.6663 2.66667 10.333 8.33333 10.333V13.6663L15 7.99967Z"
                        stroke="currentColor"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18.5 10L10.5 3V7C3.5 7 1.5 10 1.5 17C2.75 14.5 3.5 13 10.5 13V17L18.5 10Z"
                        stroke="currentColor"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
